var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({attrs:{"id":"flashmsg"}},'div',_vm.handleToast(),false))
}
var staticRenderFns = []

export { render, staticRenderFns }